import styled from '@emotion/styled';
import { Flex } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { HEALTH_STATUS } from 'constants/Global';
import { getHealthCheck } from 'modules/app/selectors';
import useTranslate from 'ui/utils/useTranslate';

const defaultValues = { values: { linebreak: <br /> } };

const HEALTH_BANNER_TRANSLATIONS = {
  [HEALTH_STATUS.DEGRADED]: (
    <FormattedMessage
      id={`healthStatus.${HEALTH_STATUS.DEGRADED}`}
      defaultMessage="Attention: We are currently experiencing some technical difficulties that may affect the app's performance, resulting in slower response times.{linebreak}Please rest assured that our team is actively working to resolve these issues as quickly as possible. We appreciate your understanding and patience during this time!"
      {...defaultValues}
    />
  ),
  [HEALTH_STATUS.UNHEALTHY]: (
    <FormattedMessage
      id={`healthStatus.${HEALTH_STATUS.UNHEALTHY}`}
      defaultMessage="We’re on it!{linebreak}Something’s gone temporarily sideways, and the app isn’t responding as it should. Our team is actively working on fixing the issue, and we’re doing everything we can to get things back up and running smoothly.{linebreak}Please check back a bit later — we appreciate your patience and understanding."
      {...defaultValues}
    />
  ),
  [HEALTH_STATUS.RELEASING]: (
    <FormattedMessage
      id={`healthStatus.${HEALTH_STATUS.RELEASING}`}
      defaultMessage="Attention: We're excited to announce that a new release is on the way! During this time, you may experience some slowness or reduced responsiveness in the app.{linebreak}We appreciate your patience as we work to improve your experience. Thank you for understanding!"
      {...defaultValues}
    />
  )
};

const Banner = styled(Flex)`
  color: #fff;
  padding: 12px 0;
  font-weight: 700;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
  linear-gradient(270deg, #eea135 0%, #ef8d36 100%);
`;

const Logo = styled.span`
  font-size: 36px;
  padding-right: 16px;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-weight: 700;
  font-size: 30px;
  cursor: pointer;
  margin-right: 1rem;
`;

/** @type {React.FC} */
const HealthBanner = () => {
  const { status, content } = useSelector(getHealthCheck);
  const [isClosed, setIsClosed] = useState(false);

  const { translate } = useTranslate();

  const handleClose = () => setIsClosed(true);

  const healthCheckContent = status === HEALTH_STATUS.PLANNED_MAINTENANCE ? translate(content) : HEALTH_BANNER_TRANSLATIONS[status];

  if (isClosed) return null;

  return (
    <Banner align="center" justify="center">
      <Flex align="center" className="mx-auto my-0">
        <Logo className="fb-icon fb-icon--info" />
        {healthCheckContent}
      </Flex>
      <CloseButton onClick={handleClose} className="fb-icon--close" data-cy="banner_Close_Btn" />
    </Banner>
  );
};

export default HealthBanner;
